
import { ModuleWithProviders, NgModule } from "@angular/core";
import { ComponentLocator } from "@nts/std";
import { CustomBlankEditorComponent } from "./components/custom-blank-editor/custom-blank-editor.component";
import { CustomEditorComponent } from "./components/custom-editor/custom-editor.component";
import { InfiniteScrollComponent } from "./components/custom-infinite-scroll/custom-infinite-scroll.component";
import { CustomMailChipsComponent } from "./components/custom-mail-chips/custom-mail-chips.component";
import { CustomPdfEditorComponent } from "./components/custom-pdf-editor/custom-pdf-editor.component";
import { EmptyContainerWithAnimationComponent } from "./components/empty-container-with-animation/empty-container-with-animation.component";
import { ErrorPageComponent } from "./components/error/error-page.component";
import { PdfPreviewComponent } from "./components/pdf-preview/pdf-preview.component";

export const SIGN_TEMPLATE_LONG_OP_SLUG = `signtemplatelongop`;
export const SIGN_TEMPLATE_LONG_OP_FULL_PATH = `/manage/${SIGN_TEMPLATE_LONG_OP_SLUG}`;

export const SIGN_TEMPLATE_SLUG = `signtemplate`;
export const SIGN_TEMPLATE_FULL_PATH = `/manage/${SIGN_TEMPLATE_SLUG}`;
export const SIGN_TEMPLATE_FULL_NAME = 'DigitalSignConfiguration.SignTemplateObjects.Models.SignTemplate';
export const NOTIFICATION_MESSAGES_SLUG = `notificationmessages`;
export const PROVISIONING_LONG_OP_SLUG = `provisioninglongop`;
export const TENANT_CREDENTIAL_SLUG = `tenantcredential`;

@NgModule({
    imports: [
        CustomBlankEditorComponent,
        CustomEditorComponent,
        InfiniteScrollComponent,
        CustomMailChipsComponent,
        CustomPdfEditorComponent,
        EmptyContainerWithAnimationComponent,
        PdfPreviewComponent,
        ErrorPageComponent
    ],
    exports: [
        CustomBlankEditorComponent,
        CustomEditorComponent,
        InfiniteScrollComponent,
        CustomMailChipsComponent,
        CustomPdfEditorComponent,
        EmptyContainerWithAnimationComponent,
        PdfPreviewComponent,
        ErrorPageComponent
    ],
    providers: []
})
export class SharedModule {

    constructor(
        protected componentLocator: ComponentLocator,
    ) {

    }

    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
        };
    }

    static forChild(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: []
        };
    }
}
